/* eslint-disable */
import { ReactNode } from "react";
import RootStore from '../stores/root-store';
import { RootStoreContext } from '../stores/root-store-context';
import { defaultConfigApi } from '../api/base/defaultConfigApi';

const rootStore = new RootStore(defaultConfigApi, false); // isFinCen = false by default

interface RootStoreProviderProps {
  children: ReactNode;
}

export const RootStoreProvider = ({ children }: RootStoreProviderProps) => (
  <RootStoreContext.Provider value={rootStore}>
    {children}
  </RootStoreContext.Provider>
);